<template>
    <div>
        <Spinner v-if="!ready" class="spinner--opaque" />
        <slot v-else></slot>
        <portal to="header-after-logo">
            <WorkspaceSelect />
        </portal>
    </div>
</template>

<script>
import Spinner from '@speechki-frontend/shared/ui/Spinner';

import WorkspaceSelect from '../WorkspaceSelect/WorkspaceSelect';

import { mapActions, mapState, mapGetters } from 'vuex';

export default {
    name: 'WorkspaceProvider',
    components: {
        Spinner,
        WorkspaceSelect,
    },

    computed: {
        ...mapState('workspaces', {
            activeWorkspace: (state) => state.activeWorkspace,
            loading: (state) => state.loading,
        }),
        ...mapGetters('workspaces', ['ready']),
        ...mapGetters(['loggedIn']),
        showSelect() {
            if (this.$route.fullPath.includes('invites')) return true;

            return !this.$route.name.includes('-id');
        },
    },

    watch: {
        loggedIn: {
            immediate: true,
            async handler(value) {
                if (value) {
                    await this.fetchWorkspacesData();

                    let localActiveWorkspace = localStorage.getItem('sp-workspace');
                    await this.setActiveWorkspace(localActiveWorkspace);
                    return;
                }

                this.clearActiveWorkspace();
            },
        },
    },

    methods: {
        ...mapActions('workspaces', [
            'fetchWorkspacesData',
            'setActiveWorkspace',
            'clearActiveWorkspace',
        ]),
    },
};
</script>
